var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup12691(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 190V14H171V190H29Z",
    fill: "#415385",
    fillOpacity: 0.51
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 150V63H149V150H62Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.6 112.4H150V162.4H50V62.4H100V75H62.6V150H137.6V112.4ZM150.4 62.4L158.8 71.2L103.2 125L75 97.8L83.4 89L103.2 108L150.4 62.4ZM168.8 12.4C172.267 12.4 175.2 13.6667 177.6 16.2C180 18.6 181.2 21.5333 181.2 25V187.6C181.2 190.933 180 193.8 177.6 196.2C175.2 198.733 172.267 200 168.8 200H31.2C27.8667 200 24.9333 198.733 22.4 196.2C20 193.8 18.8 190.933 18.8 187.6V25C18.8 21.5333 20 18.6 22.4 16.2C24.8 13.6667 27.7333 12.4 31.2 12.4H50V25H31.2V187.6H168.8V25H150V12.4H168.8ZM62.6 12.4V0H137.6V12.4H62.6Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup12691);
export default __webpack_public_path__ + "static/media/group12691.a696ed9d6b6cb8b7e2d16ea1929ebadb.svg";
export { ForwardRef as ReactComponent };